import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { BookingList } from "./bookingList";

const bookingBreadcrumbs: Array<PageLink> = [
  {
    title: "Subscribed Data",
    path: "/bookings/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const BookingPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={bookingBreadcrumbs}>Bookings</PageTitle>
              <BookingList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/bookings/list" />} />
    </Routes>
  );
};

export default BookingPage;
